import React, { useState } from "react";
import SvgInline from "../../SvgInline";

import SuccessIcon from "!svg-inline-loader!./success.svg";
import WaitIcon from "!svg-inline-loader!./wait.svg";
import PenaltyIcon from "!svg-inline-loader!./penalty.svg";
import FailIcon from "!svg-inline-loader!./reject.svg";
import EditIcon from "!svg-inline-loader!./edit.svg";

import GradeWaitIcon from "!svg-inline-loader!./grade_wait.svg";
import GradePayedIcon from "!svg-inline-loader!./grade_payed.svg";
import GradeNotPayedIcon from "!svg-inline-loader!./grade_not_payed.svg";

import { payoutStatus, gradeStatus } from "../../../constants";

const iconsMap = {
  [payoutStatus.success]: SuccessIcon,
  [payoutStatus.fail]: FailIcon,
  [payoutStatus.penalty]: PenaltyIcon,
  [payoutStatus.wait]: WaitIcon,
  [payoutStatus.edit]: EditIcon
};

const gradeIconMap = {
  [gradeStatus.wait]: GradeWaitIcon,
  [gradeStatus.payed]: GradePayedIcon,
  [gradeStatus.notPayed]: GradeNotPayedIcon
};

const PayoutStatus = ({ status, gradeStatus, reasons, showReasons }) => {
  const [visible, setVisible] = useState(false);
  const icon = iconsMap[status];
  const gradeIcon = gradeIconMap[gradeStatus];

  return (
    <div
      className="payout-status-wrapper"
      onMouseEnter={() => {
        setVisible(true);
      }}
      onMouseLeave={() => {
        setVisible(false);
      }}
      onClick={() => {
        // setVisible(prev => !prev);
      }}
    >
      <SvgInline src={icon} />
      <SvgInline src={gradeIcon} />

      {visible && showReasons && (
        <div className="payout-status-wrapper__reasons">
          <div className="payout-status-wrapper__content">
            {reasons.map(reason => (
              <div>{reason.message}</div>
            ))}
            <div>
              Сумма:{" "}
              {reasons.reduce((prev, current) => {
                return prev + current.price;
              }, 0)}
            </div>
            <div className="payout-status-wrapper__ico" />
          </div>
        </div>
      )}
    </div>
  );
};

export default PayoutStatus;
